import { render, staticRenderFns } from "./unsaved-changes.vue?vue&type=template&id=22bd7c6f&scoped=true&"
import script from "./unsaved-changes.vue?vue&type=script&lang=ts&"
export * from "./unsaved-changes.vue?vue&type=script&lang=ts&"
import style0 from "./unsaved-changes.vue?vue&type=style&index=0&id=22bd7c6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd7c6f",
  null
  
)

export default component.exports